/**
 * Base entity model. All Apollon models should inherit this class.
 *
 * This file is part of Zeus Apollon
 *
 * (c) Kaden und Partner AG
 */
import { BaseModel } from '@/models/BaseModel';
import { BaseCollection } from './BaseCollection';
import type { Dayjs } from 'dayjs';
import type { MutationsObject } from '@kp/js-model';

export enum AdresseTyp {
    PERSON = 'person',
    ORGANISATION = 'organisation'
}

export type AdresseRolle = 'eigentuemer' | 'unternehmer' | 'bevollmaechtigter' | 'kontakt'

export class Adresse extends BaseModel {
    id: number | null = null;
    ersteller_id: number | null = null;
    typ: AdresseTyp | null = null;
    anrede: string | null = null;
    vorname: string | null = null;
    nachname: string | null = null;
    organisation_name: string | null = null;
    organisation_tel_1: string | null = null;
    organisation_tel_2: string | null = null;
    organisation_email: string | null = null;
    strasse: string | null = null;
    strasse_nr: string | null = null;
    adresszusatz: string | null = null;
    postfach: string | null = null;
    plz: string | null = null;
    ort: string | null = null;
    kanton_kuerzel: string | null = null;
    tel_1: string | null = null;
    tel_2: string | null = null;
    email: string | null = null;
    created: Dayjs | null = null;
    modified: Dayjs | null = null;
    uid: string | null = null;
    land_id: number | null = null;
    anrede2: string | null = null;
    vorname2: string | null = null;
    nachname2: string | null = null;
    eigentuemerschaft: string | null = null;
    benutzer_id: number | null = null;

    // View fields:
    laendercode: string | null = null;
    land: string | null = null



    public mutations(): MutationsObject {
        return {
            id: (id) => (Number(id) > 0 ? Number(id) : null),
            land_id: (id) => (Number(id) > 0 ? Number(id) : null)
        };
    }

    get vorname_name() {
        return [this.vorname, this.nachname].filter((e) => e !== null).join(' ');
    }

    set vorname_name(value: string) { }

    get display_name() {
        if (this.typ === 'organisation') {
            return this.organisation_name;
        }
        return this.nachname;
    }

    set display_name(value: string | null) { }

    get adresse() {
        return [this.strasse, this.strasse_nr].filter((e) => e !== null).join(' ');
    }
    set adresse(value: string | null) { }

    get plz_ort() {
        return [this.plz, this.ort].filter((e) => e !== null).join(' ');
    }
    set plz_ort(value: string | null) { }


    getClassName(): string {
        return 'adressen';
    }

}

export class AdresseCollection extends BaseCollection<Adresse> {
    protected modelCls = Adresse;

    public getModelClassName(): string {
        return 'adressen';
    }
}